export default __webpack_public_path__ + "static/media/demo.8ce51a1e.jpg";